var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomFoodYellow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.307 9.272c1.147.205 2.089.82 2.825 1.847.647.908 1.089 2.052 1.324 3.43.206 1.26.19 2.52-.044 3.78-.354 2.082-1.06 3.826-2.12 5.233-1.265 1.7-2.854 2.55-4.767 2.55-.47 0-.985-.146-1.545-.44a2.403 2.403 0 0 0-1.28-.351c-.471 0-.897.117-1.28.351-.56.294-1.074.44-1.545.44-1.913 0-3.502-.85-4.768-2.55-1.06-1.407-1.765-3.151-2.119-5.232a10.88 10.88 0 0 1-.044-3.782c.235-1.377.677-2.52 1.324-3.43.736-1.025 1.678-1.64 2.825-1.846.707-.117 1.678-.015 2.914.308 1.06.293 1.957.645 2.693 1.055.735-.41 1.633-.762 2.692-1.055 1.237-.323 2.208-.425 2.915-.308z",
    fill: "#F6C760",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.879 7.47c-.412.38-.957.659-1.634.835-.471.146-.985.22-1.545.22l-.662-.044a5.613 5.613 0 0 1 0-1.407c.118-1.056.456-1.862 1.015-2.419.412-.381.957-.66 1.634-.835.47-.147.985-.22 1.545-.22l.662.044.044.66c0 .557-.074 1.07-.22 1.538-.177.674-.456 1.217-.84 1.627z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomFoodYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-food-yellow.7a90c0833ad65a7e9dc99efa8f964200.svg";